import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

function useCustomSearchParams() {
  const location = useLocation();
  
  return useMemo(() => {
    const fullUrl = window.location.href;
    const [beforeHash, afterHash] = fullUrl.split('#');
    const searchString = beforeHash.split('?')[1] || '';
    const hashSearchString = afterHash ? afterHash.split('?')[1] : '';
    
    const combinedSearchString = searchString + 
      (searchString && hashSearchString ? '&' : '') + 
      hashSearchString;
    
    return new URLSearchParams(combinedSearchString);
  }, [location]);
}

export default useCustomSearchParams;